var map = {
	"./ABX Express.png": "eee4",
	"./Addresses.png": "cdfd",
	"./After 5.png": "49a6",
	"./Airpak Express.png": "4aee",
	"./Aladdin.png": "05f09",
	"./Aramex.png": "52ff",
	"./AsiaXpress.png": "85e1",
	"./Atri Xpress.png": "b070",
	"./CJ Century.png": "070c",
	"./CarPal.png": "4cc9",
	"./City-Link Express.png": "4833",
	"./Collectco.png": "b325",
	"./Cool TAQBIN.png": "0d59",
	"./Cuckoo Express.png": "e988",
	"./DCS.png": "16cc",
	"./DD Express.png": "f386",
	"./DHL eCommerce.png": "e6ff",
	"./DHL.png": "ae59",
	"./DPE Express.png": "9a8c",
	"./DeliverLAH.png": "45df",
	"./Delivery Guys.png": "9d2e",
	"./EMS.png": "c150",
	"./Ecargo Express.png": "a6f9",
	"./FMX.png": "8e9c",
	"./FedEx.png": "662e",
	"./First Logistics.png": "d338",
	"./GDex.png": "3159",
	"./GoLog.png": "c5e2",
	"./Grab Express.png": "78af",
	"./J&T Express.png": "c882",
	"./JNE Express.png": "7d44",
	"./Janio.png": "b33d",
	"./Jet-Ship Worldwide.png": "ba1c",
	"./Jocom.png": "75b3",
	"./KTMD Malaysia.png": "1477",
	"./Karhoo Courier.png": "3ca0",
	"./LWE.png": "f2a0",
	"./Lazada eLogistics (LEL).png": "ecac1",
	"./Leopards Express.png": "b3a1",
	"./Line Clear Express.png": "b7e2",
	"./MRight.png": "89e2",
	"./MXpress.png": "9959",
	"./MatDespatch.png": "1e5f",
	"./May Express.png": "3eaa",
	"./MyPoz.png": "13d1",
	"./Mypostonline.png": "6969",
	"./Nationwide Express.png": "c7d9",
	"./Near U.png": "6d71",
	"./NinjaVan.png": "a2f8",
	"./OWL-Transport.png": "4876",
	"./PCP Express.png": "fb22",
	"./Park N Parcel.png": "3509",
	"./Pgeon.png": "a31f",
	"./Pickupp.png": "1e97",
	"./Ping U.png": "66f7",
	"./Poslaju.png": "eda1",
	"./Postco.png": "4519",
	"./Quantium Solution.png": "5509",
	"./Qxpress.png": "01d1",
	"./Roadbull.png": "25aa",
	"./SCG.png": "a112",
	"./SF Express.png": "c16b",
	"./SPC Worldwide Express.png": "f0d2",
	"./Shark-Delivery.png": "de0f",
	"./ShopeeXpress.png": "9ace",
	"./Skynet Express.png": "bc59",
	"./SnT Global.png": "c458",
	"./Sure Reach.png": "e8b51",
	"./TAQBIN Malaysia.png": "3201",
	"./TNT.png": "0449",
	"./Teleport.png": "87a6",
	"./Transprompt Freight.png": "c379",
	"./UPS.png": "48dc",
	"./UTS Logistics.png": "ea21",
	"./Ultimate Consolidators.png": "ccc3",
	"./UrbanFox.png": "3f7e",
	"./WePost.png": "6814",
	"./XDel.png": "0b61",
	"./ZOOMIT.png": "2dc2",
	"./Zepto Express.png": "06e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e09f8";